import React, { Component } from "react";
import BUSDChartLine from "./BUSDChartLine";

import { TabView, TabPanel } from "primereact/tabview";
import ModelDashboardV2 from "../../models/ModelDashboardV2";
import moment from "moment";

import { checkWorkingTime, showLog } from '../../helpers/default';
import ForeignChart from "./ForeignComponent/ForeignChart";
import ForeignScore from "./ForeignComponent/ForeignScore";
import BusdChart from "./BusdComponent/BusdChart";
import BusdScore from "./BusdComponent/BusdScore";
import { Dropdown } from 'primereact/dropdown';
class BusdView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 1,
            display: true,
            selCorrection: localStorage.getItem('busd_Correction') ? JSON.parse(localStorage.getItem('busd_Correction')) : { 'name': 'Nguyên Bản', 'code': 'Nguyên Bản' },
            optCorrection: [
                { 'name': 'Nguyên Bản', 'code': 'Nguyên Bản' },
                { 'name': 'MACD BUSD', 'code': 'MACD BUSD' },
                { 'name': 'Threshold', 'code': 'Threshold' },
            ],
        };

        this.model = new ModelDashboardV2()
    }
    async getData(day) {

        this.setState({
            day: day,
            lastTimestamp: moment(day, 'YYYY_MM_DD').startOf('day').add(9, 'hours').valueOf() / 1000,
        }, async () => {
            let paramter = {
                "day": this.state.day,
                "lastTimestamp": this.state.lastTimestamp,
                "indicator_correction": {
                    busd: this.state.selCorrection['code'],
                }
            }

            let data = await this.model.get_data_busd(false, paramter)


            let { BU_5min, SD_5min, NetBUSD_5min, BUSD_Point_5min, lastPoint } = this.handleData(data)
            if (this.state.activeIndex == 0) {
                this.BusdChart.loadData(BU_5min, SD_5min, NetBUSD_5min)
            }
            if (this.state.activeIndex == 1) {
                this.BusdScore.loadData(BUSD_Point_5min)
            }

            this.BUSDChartLine.setContent(lastPoint)
        });
    }
    // update realtime data price
    async updateData() {
        if (checkWorkingTime()) {

            if (moment(this.state.lastTimestamp, "X").format('YYYY_MM_DD') != moment().format('YYYY_MM_DD')) {
                return
            }

            let paramter = {
                "day": this.state.day,
                "lastTimestamp": this.state.lastTimestamp,
                "indicator_correction": {
                    busd: this.state.selCorrection['code'],
                }
            }

            let data = await this.model.get_data_busd(false, paramter)

            if (data.length > 0) {
                var { BU_5min, SD_5min, NetBUSD_5min, BUSD_Point_5min, lastPoint } = this.handleData(data)
                if (this.state.activeIndex == 0) {

                    let preData = this.BusdChart.chart.data


                    preData[0]['x'].push(...BU_5min['x'])
                    preData[0]['y'].push(...BU_5min['y'])
                    preData[1]['x'].push(...SD_5min['x'])
                    preData[1]['y'].push(...SD_5min['y'])
                    preData[2]['x'].push(...NetBUSD_5min['x'])
                    preData[2]['y'].push(...NetBUSD_5min['y'])
                    this.BusdChart.chart.data = preData
                    global.Plotly.redraw(this.BusdChart.chart)

                    this.BusdChart.updateXAxis(preData[0]['x'])
                }
                if (this.state.activeIndex == 1) {
                    let preData = this.BusdScore.chart.data
                    preData[0]['x'].push(...BUSD_Point_5min['x'])
                    preData[0]['y'].push(...BUSD_Point_5min['y'])
                    this.BusdScore.chart.data = preData
                    global.Plotly.redraw(this.BusdScore.chart)

                    this.BusdScore.updateXAxis(preData[0]['x'])
                }

                this.BUSDChartLine.setContent(lastPoint)


            }




        }


    }

    handleData(res) {
        let BU_5min = {
            'x': [],
            'y': [],
        }
        let SD_5min = {
            'x': [],
            'y': [],

        }
        let NetBUSD_5min = {
            'x': [],
            'y': [],

        }
        let BUSD_Point_5min = {
            'x': [],
            'y': [],

        }
        let lastPoint = 0
        res.map((item, idx) => {
            let time = moment.unix(item['timestamp']).format("HH:mm:ss")
            BU_5min['x'].push(time)
            BU_5min['y'].push(item['BU_5min'] != undefined ? item['BU_5min'] : 0 )
            SD_5min['x'].push(time)
            SD_5min['y'].push( item['SD_5min'] != undefined ? item['SD_5min'] : 0 )
            NetBUSD_5min['x'].push(time)
            NetBUSD_5min['y'].push(item['NetBUSD_5min'] != undefined ? item['NetBUSD_5min'] : 0)
            BUSD_Point_5min['x'].push(time)
            BUSD_Point_5min['y'].push(item['BUSD_Point_5min'] != undefined ? item['BUSD_Point_5min'] : 0 )
            if (res.length == idx + 1) {
                this.setState({
                    lastTimestamp: item['timestamp']
                });
                lastPoint = item['BUSD_Point_5min']
            }



        })


        return {
            BU_5min, SD_5min, NetBUSD_5min, BUSD_Point_5min, lastPoint
        }
    }
    componentDidMount() {
        if (this.props.day != '') {
            this.getData(this.props.day)


            if (Object.keys(this.props.note).length > 0) {
                this.setState({
                    note: this.props.note['Busd']
                });
            }


            if (checkWorkingTime()) {
                this.interval = setInterval(() => {
                    this.updateData()
                }, 5000);
            }
        }
    }
    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);
    }
    renderInfo() {
        return (
            <div style={{ whiteSpace: 'pre-wrap', margin: '-20px 0px 20px 20px' }}>{this.state.note}</div>
        );
    }

    render() {
        return (
            <div style={this.state.display ? { marginTop: 20 } : { marginTop: 10 }}>


                <div style={{ marginBottom: 20, cursor: 'pointer', display: 'flex', alignItems: 'center' }} >
                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => this.setState({ display: !this.state.display })}>
                        <span>Busd Scoring</span>

                        <i style={{ marginLeft: 10, marginTop: 3 }} className={this.state.display ? "pi pi-angle-up" : "pi pi-angle-down"}></i>
                    </div>

                    <Dropdown
                        value={this.state.selCorrection}
                        options={this.state.optCorrection}
                        onChange={(e) => { 
                            localStorage.setItem("busd_Correction", JSON.stringify(e.value));
                            this.setState({
                                selCorrection: e.value,
                                lastTimestamp: moment(this.state.day, 'YYYY_MM_DD').startOf('day').add(9, 'hours').valueOf() / 1000
                            },
                                () => {
                                    if (this.interval) {
                                        clearInterval(this.interval);
                                    }
                                    this.getData(this.state.day)
                                    let ChartTotalScoreView = this.props.ChartTotalScoreView()
                                    ChartTotalScoreView.changeIndicator_correction({'busd' : this.state.selCorrection['code']})
                                    if (checkWorkingTime()) {
                                        this.interval = setInterval(() => {
                                            this.updateData()
                                        }, 5000);
                                    }
                                }
                            );
                        }}
                        optionLabel="name"
                        style={{ margin: "0px 10px" }}

                    />
                </div>
                <div
                    className="grid"
                    style={{
                        background: "white",
                        marginBottom: 20,
                        borderRadius: 8,
                        marginLeft: 1,
                        maxHeight: this.state.display ? "500px" : '0',
                        transition: 'all .5s',
                        overflow: 'hidden'
                    }}
                >
                    <div className="col-12 md:col-4">
                        <BUSDChartLine config={{ score: 4 }} ref={c => this.BUSDChartLine = c}></BUSDChartLine>
                    </div>
                    <div className="col-12 md:col-8">
                        <div style={{ marginLeft: 25 }}>
                            <TabView
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => {
                                    this.setState({
                                        activeIndex: e.index,
                                        // lastTimestamp: moment().startOf('day').add(9, 'hours').valueOf() / 1000

                                        lastTimestamp: moment(this.state.day, 'YYYY_MM_DD').startOf('day').add(9, 'hours').valueOf() / 1000
                                    },
                                        () => {
                                            if (this.interval) {
                                                clearInterval(this.interval);
                                            }
                                            this.getData(this.state.day)
                                            if (checkWorkingTime()) {
                                                this.interval = setInterval(() => {
                                                    this.updateData()
                                                }, 5000);
                                            }
                                        }
                                    );

                                }}
                            >
                                <TabPanel header="Busd"></TabPanel>
                                <TabPanel header="Busd Score"></TabPanel>
                                <TabPanel header="Info"></TabPanel>
                            </TabView>
                        </div>

                        {/* {this.state.activeIndex == 0 ? (
                            <BusdChart ref={c => this.BusdChart = c}></BusdChart>
                        ) : (
                            <BusdScore ref={c => this.BusdScore = c}></BusdScore>
                        )} */}
                        {this.state.activeIndex == 0 ? (
                            <BusdChart ref={c => this.BusdChart = c}></BusdChart>
                        ) : this.state.activeIndex == 1 ? (
                            <BusdScore ref={c => this.BusdScore = c}></BusdScore>
                        ) :
                            this.renderInfo()
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default BusdView;
